<script setup lang="ts">
const router = useRouter();
const route = useRoute();

type ListingFilter = {
  code: string;
  min?: number;
  max?: number;
  label: string;
};

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: Record<string, any>;
}>();

const prices = ref<number[]>([]);

watch(
  () => [
    props.selectedFilters?.price["min"],
    props.selectedFilters?.price["max"],
  ],
  ([newMin, newMax]) => {
    if (!newMin) {
      prices.value[0] = Math.floor(props.filter?.min || 0);
    } else {
      prices.value[0] = Math.floor(newMin);
    }

    if (!newMax) {
      prices.value[1] = Math.floor(props.filter?.max || 0);
    } else {
      prices.value[1] = Math.floor(newMax);
    }
  },
  { immediate: true }
);

function onMinPriceChange(newPrice: number, oldPrice: number) {
  if (
    newPrice === oldPrice ||
    oldPrice === 0 ||
    newPrice === Math.floor(props.filter?.min)
  )
    return;

  router.push({
    query: { ...route.query, p: 1, "min-price": newPrice || undefined },
  });
}
const debounceMinPriceUpdate = useDebounceFn(onMinPriceChange, 500);
watch(() => prices.value[0], debounceMinPriceUpdate);

function onMaxPriceChange(newPrice: number, oldPrice: number) {
  if (
    newPrice === oldPrice ||
    oldPrice === 0 ||
    newPrice === Math.floor(props.filter?.max)
  )
    return;

  router.push({
    query: { ...route.query, p: 1, "max-price": newPrice || undefined },
  });
}
const debounceMaxPriceUpdate = useDebounceFn(onMaxPriceChange, 500);
watch(() => prices.value[1], debounceMaxPriceUpdate);
</script>

<template>
  <div v-if="filter.max !== filter.min" class="flex flex-col gap-4">
    <Slider
      v-model="prices"
      :min="filter.min && Math.floor(filter.min)"
      :max="filter.max && Math.floor(filter.max)"
      range
      class="w-11/12 self-center"
    />

    <div class="flex items-center gap-2">
      <InputNumber
        v-model="prices[0]"
        inputId="min-button"
        mode="currency"
        currency="EUR"
        showButtons
        input-class="w-1/2"
        :min="filter.min && Math.floor(filter.min)"
        :max="filter.max && Math.floor(filter.max - 1)"
        locale="lt-LT"
      />
      -
      <InputNumber
        v-model="prices[1]"
        inputId="max-button"
        mode="currency"
        currency="EUR"
        showButtons
        input-class="w-1/2"
        :min="filter.min && Math.floor(filter.min + 1)"
        :max="filter.max && Math.floor(filter.max)"
        locale="lt-LT"
      />
    </div>
  </div>
</template>
